import * as React from 'react';

type Props = {
  height: string;
  width: string;
  fill: string;
};

const MinusFilled = (props: Props) => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <g>
        <path d="M0,0V100H100V0H0zM20,43H80V57H20V43z" />
      </g>
    </svg>
  );
};

export default MinusFilled;
